
export function renderNetraaLHReleaseNotes5 () {
    return (
  <div>
    <main className="transition-opacity duration-300">
      <div className="py-4">

        {/* Header */}
        <div className="mb-10 scroll-mt-24" id="release-details">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
            Release Notes
          </span>

          <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
              Netraa LH – Latest Enhancements & Fixes
            </span>
          </h1>

          <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
            We are excited to introduce the latest updates to Netraa LH. This release focuses on improving usability, enhancing performance, and delivering a smoother user experience across the platform.
          </p>
        </div>

        {/* Release Info Table */}
        <section className="mb-12 scroll-mt-24" id="">
          <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
            Release Details
          </h2>

          <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
            <table className="w-auto text-left border-collapse text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Date</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Release Type</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Author Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 font-medium text-primary">13th Feb 2026</td>
                  <td className="px-4 py-3">Enhancements & Fixes</td>
                  <td className="px-4 py-3">Navodya Tyagi</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Features */}
        <section className="mb-16 scroll-mt-24" id="features">
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-8">
            New Enhancements & Fixes
          </h2>

          <div className="grid gap-5">

            {[ 
              {
                title: "Platform Logos on Live Dashboard",
                content: "Platform logos are now visible on the Live Dashboard, improving platform identification and overall visual clarity."
              },
              {
                title: "Live Dashboard Filter Improvements",
                content: "The Success, Running, and Terminated filters have been refined and now function reliably as intended."
              },
              {
                title: "Historical Data Table Enhancements (Live Dashboard)",
                list: [
                  "Users can now view error messages for terminated executions.",
                  "Error messages display an underline on hover, indicating interactivity.",
                  "Clicking an error message opens a pop-up with a screenshot and detailed error information.",
                  "A Copy button allows quick copying of error messages.",
                  "Error screenshots can be downloaded directly from the pop-up."
                ]
              },
              {
                title: "Bulk Reports Download Fix",
                content: "An issue affecting bulk report downloads has been resolved."
              },
              {
                title: "Performance Improvements",
                content: "Performance optimizations have been applied to the Live Dashboard and the “What Went Wrong” page, improving responsiveness and overall efficiency."
              }
            ].map((item, index) => (
              
              <div
                key={index}
                className="group p-5 rounded-2xl border border-border-color dark:border-border-dark bg-surface-light dark:bg-surface-dark hover:shadow-md hover:-translate-y-[2px] transition-all duration-200 h-full scroll-mt-24"
              >
                <div className="flex items-center gap-4">

                  {/* Number Badge */}
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 text-sm font-bold flex-shrink-0">
                    {index + 1}
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h4 className="font-semibold text-text-main dark:text-white mb-2">
                      {item.title}
                    </h4>

                    {item.content && (
                      <p className="text-sm text-text-muted dark:text-gray-400 leading-relaxed">
                        {item.content}
                      </p>
                    )}

                    {item.list && (
                      <ul className="list-disc pl-5 space-y-1 text-sm text-text-muted dark:text-gray-400">
                        {item.list.map((li, i) => (
                          <li key={i}>{li}</li>
                        ))}
                      </ul>
                    )}
                  </div>

                </div>
              </div>

            ))}

          </div>
        </section>

        {/* Document Authors */}
        <section className="mb-12 scroll-mt-24">
          <h2 className="text-xl font-bold text-text-main dark:text-white mb-4">
            Document Authors
          </h2>

          <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
            <table className="w-auto text-left border-collapse text-sm">
              <thead>
                <tr>
                  <th className="px-4 py-3 font-bold text-text-muted">Name</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Title</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Email</th>
                  <th className="px-4 py-3 font-bold text-text-muted">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 font-medium text-primary">Navodya Tyagi</td>
                  <td className="px-4 py-3">Project Manager</td>
                  <td className="px-4 py-3">navodya.tyagi@ap2l.ai</td>
                  <td className="px-4 py-3">13th Feb, 2026</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

      </div>
    </main>
  </div>
);
}